import type {TranslateT} from '@freckle/educator-entities/ts/common/helpers/translate'
import {TriSectionProgressBar} from '@freckle/educator-materials/ts/components/trisection-progress-bar'

export function formatProgressBar(
  belowGrade: number,
  withinGrade: number,
  aboveGrade: number,
  t: TranslateT,
) {
  // Classes applied conditionally due to use of borders in print view
  return (
    <TriSectionProgressBar
      leftStat={belowGrade}
      middleStat={withinGrade}
      rightStat={aboveGrade}
      leftPopoverText={t('PROFICIENCY_REPORT_TABLE_PROGRESS_BAR_BELOW')}
      middlePopoverText={t('PROFICIENCY_REPORT_TABLE_PROGRESS_BAR_WITHIN')}
      rightPopoverText={t('PROFICIENCY_REPORT_TABLE_PROGRESS_BAR_ABOVE')}
      leftClassName={belowGrade === 0 ? '' : 'progress-bar-below'}
      middleClassName={withinGrade === 0 ? '' : 'progress-bar-within'}
      rightClassName={aboveGrade === 0 ? '' : 'progress-bar-above'}
    />
  )
}
